<template>
  <!-- NOTE (TEMPLATE) to show the specific proposal page -->

  <div>
    <!-- loading component -->
    <Loading />
    <Proposal role="admin" />
  </div>
</template>

<script>
const Proposal = () => import("../../components/Proposal");

export default {
  components: {
    Proposal // NOTE (c-proposal) component of proposal
  },
  data() {
    return {};
  },

  methods: {}
};
// REVIEW mounted
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
